import React from 'react';
import cs from 'classnames';
import styles from './MimeTypeFileIcon.module.scss';
import ExcelFile from '../../Icons/FileTypes/ExcelFile';
import GenericFile from '../../Icons/FileTypes/GenericFile';
import ImageFile from '../../Icons/FileTypes/ImageFile';
import PDFFile from '../../Icons/FileTypes/PDFFile';
import PowerpointFile from '../../Icons/FileTypes/PowerpointFile';
import TextFile from '../../Icons/FileTypes/TextFile';
import WordFile from '../../Icons/FileTypes/WordFile';
var mimeTypes = {
  'application/msword': 'word',
  'application/pdf': 'pdf',
  'application/rtf': 'text',
  'application/vnd.ms-excel': 'excel',
  'application/vnd.ms-powerpoint': 'powerpoint',
  'application/vnd.oasis.opendocument.presentation': 'powerpoint',
  'application/vnd.oasis.opendocument.spreadsheet': 'excel',
  'application/vnd.oasis.opendocument.text': 'word',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'powerpoint',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
  'image/gif': 'image',
  'image/jpeg': 'image',
  'image/png': 'image',
  'image/svg+xml': 'image',
  'image/tiff': 'image',
  'image/webp': 'image',
  'image/x-icon': 'image',
  'text/css': 'text',
  'text/csv': 'text',
  'text/html': 'text',
  'text/plain': 'text'
};
var icons = {
  excel: ExcelFile,
  generic: GenericFile,
  image: ImageFile,
  pdf: PDFFile,
  powerpoint: PowerpointFile,
  text: TextFile,
  word: WordFile
};
export default function MimeTypeFileIcon(props) {
  var className = props.className,
    height = props.height,
    mimeType = props.mimeType,
    width = props.width;
  var iconType = mimeTypes[mimeType] || 'generic';
  var Icon = icons[iconType];
  return /*#__PURE__*/React.createElement(Icon, {
    className: cs(className, styles['icon'], styles[iconType]),
    height: height,
    width: width
  });
}